/* @ngInject */

export default () => {
  function getInitials(_name, _limit, _separator) {
    var output = '';
    if (!_name) {
      return output;
    } else {
      var max = _limit || 2;
      var separator = _separator || ' ';
      var words = _name.split(separator);
      var len = words.length < max ? words.length : max;
      while (len--) {
        output = words[len].charAt(0) + output;
      }
      return output.toUpperCase();
    }
  }

  var service = {
    getInitials: getInitials
  };

  return service;
};
